import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { AUTOMATION_QUERY_KEYS } from '../../queryKeys';

interface Params {
	templateId: string;
	stepType: Api.AutomationStepType;
	step: Api.IAutomationStep;
	beforeStepId?: string;
	impersonationContext?: Api.IImpersonationContext;
}

export function useAddAutomationStepMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.IAutomationStep, variables: Params) => void;
	onError?: (error: Api.IOperationResultNoValue, variables: Params) => void;
} = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ templateId, stepType, step, beforeStepId, impersonationContext }: Params) => {
			const queryParams = beforeStepId ? `?beforeId=${encodeURIComponent(beforeStepId)}` : '';
			return userSession.webServiceHelper.callAsync<Api.IAutomationStep>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/${encodeURIComponent(
						stepType
					)}${queryParams}`,
					impersonationContext,
				}),
				'POST',
				step
			);
		},
		onSuccess: (data, variables) => {
			queryClient.invalidateQueries({ queryKey: AUTOMATION_QUERY_KEYS.template(variables.templateId) });
			onSuccess?.(data, variables);
		},
		onError,
	});
}
